import { zCorpSessionDom } from "@/types/corp/corpSession.domain";
import { zCorpWhoamiDto } from "@/types/corp/corpSession.dto";
/**
 * Read-only маппер сессии корп-админа (RPC corp_whoami()).
 * CRUD-паттерн makeSimpleMapper здесь не подходит — нет write-направления.
 */
export const CorpSessionMapper = {
    toDomain(dto) {
        return zCorpSessionDom.parse(zCorpWhoamiDto.parse(dto));
    },
};
